module.exports = __webpack_public_path__ + "static/img/id_tip_img.ffa9f2c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/id_tip_img.png
// module id = AGFr
// module chunks = 1